
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"-4 -4 24 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 12H-4V-4h24z","fill":"#d52b1e"}}),_c('path',{attrs:{"d":"M4 4h16v-8H-4z","fill":"#fff"}}),_c('path',{attrs:{"d":"M4 4h-8v-8h8z","fill":"#0039a6"}}),_c('g',{attrs:{"id":"c"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"d":"M0-2v2h1z","fill":"#fff","transform":"rotate(18 0 -2)","id":"a"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"scale(-1 1)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(72)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(-72)"}}),_c('use',{attrs:{"xlink:href":"#c","transform":"rotate(144)"}})])
          )
        }
      }
    